import React from "react";
import { Helmet } from "react-helmet";
import MultiLingualContent from "../../../languages/MultiLingualContent";
import BackButton from "../../backButton";
import sfatanit1 from "../../../assets/images/sfatanit1.jpeg";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Sfatanit = () => {
  return (
    <div className="inner-section" id="sfatanit">
      <Helmet>
        <title>פטרידע - הפטריה שפתנית</title>
        <meta
          name="description"
          content="הפטריה שפתנית - Cheilymenia: תאור, זיהוי ותמונות"
        />
      </Helmet>
      <BackButton path="/#types-and-species" />
      <h2>
        <MultiLingualContent contentID="sfatanit" />
      </h2>
      <>
        <div className="informationText">
          <p>
            <MultiLingualContent contentID="sfatanitText1" />
          </p>
          <p>
            <MultiLingualContent contentID="sfatanitText2" />
          </p>
          <br />
          <p>
            <b>
              <MultiLingualContent contentID="sfatanitText3Bold" />
            </b>
          </p>
          <p>
            <MultiLingualContent contentID="sfatanitText4" />
          </p>
          <p>
            <MultiLingualContent contentID="sfatanitText5" />
          </p>
          <div className="informationImages">
            <div className="imgWrapper">
              <LazyLoadImage src={sfatanit1} alt="שפתנית" />
              <p>
                <MultiLingualContent contentID="sfatanitImg1" />
              </p>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default Sfatanit;
